<template>
  <div class="core_layout">
    <v-app-bar
      app
      :color="color"
      :dark="!light"
      :flat="flat"
      :hide-on-scroll="hideOnScroll"
      :light="light"
      :outlined="!flat"
      rounded
      short
    >
      <v-btn v-if="goBack" icon @click="$router.back()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title v-if="title">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="toolbar-right"></slot>
    </v-app-bar>
    <v-divider v-if="divider"></v-divider>
    <v-main>
      <slot></slot>
    </v-main>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    divider: Boolean,
    flat: Boolean,
    goBack: Boolean,
    hideOnScroll: Boolean,
    light: Boolean,
    title: String
  }
}
</script>
